<template>
  <div>
    <h2>FAQ / Важное</h2>

    <div class="row articles">
      <router-link
        v-for="(article, articleIndex) of articles"
        :key="articleIndex"
        :to="{ name: article.name}"
        tag="div"
        class="col-xs-12 col-sm-6 col-md-4 col-lg-3 article-preview-container"
      >
        <div class="article-preview shadow-hover">
          <div
            class="img"
            :style="{ backgroundImage: `url(${article.img})` }"
          />
          <div class="body">
            <p
              class="title"
              v-text="article.title"
            />
            <p
              class="description"
              v-text="article.text"
            />
            <button
              class="btn background-white border-danger text-danger"
              :to="{ name: article.name}"
            >
              Узнать больше
            </button>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  data () {
    return {
      articles: [
        {
          name: 'FaqCheapseo',
          title: 'SEO-продвижение быстро и дешево? Будьте осторожны!',
          text: 'Практическая инструкция по комплексной оценке уровня надежности SEO-компании. В данном разделе представлена информация, которая позволит Вам быстро выявлять предложения недобросовестных оптимизаторов и обезопасить Ваш сайт и бизнес.',
          img: require('../../img/faq/01.jpg')
        },
        {
          name: 'FaqAboutSeoText',
          title: 'Памятка по работе с seo-текстами для клиента Demis Group',
          text: 'Памятка по SEO-копирайтингу для клиентов Demis Group. В данном разделе мы предлагаем Вам ознакомиться с вариантами взаимодействия по наполнению сайта seo-текстами, для успешного продвижения сайта.',
          img: require('../../img/faq/02.jpg')
        },
        {
          name: 'SpecialOffer',
          title: 'Программа Привилегий',
          text: 'В этом разделе Вы можете посмотреть актуальную информацию по бонусам, скидкам и подаркам, которые предусмотрены для Вас Программой Привилегий Demis Group.',
          img: require('../../img/faq/03.jpg')
        },
        {
          name: 'FaqHowToWork',
          title: 'Информация по работе с данным сервисом',
          text: 'В данном разделе вы можете ознакомиться с основными функциям сервиса client.demis.ru и научиться использовать предоставленные возможности по максимуму.',
          img: require('../../img/faq/04.jpg')
        },
        {
          name: 'FaqAboutDemis',
          title: 'Памятка клиенту по работе с компанией Demis Group',
          text: 'Памятка по SEO для клиентов Demis Group. Информация о том, что необходимо делать с сайтом, чтобы быстрее выйти на высокие позиции в поисковых системах.',
          img: require('../../img/faq/05.jpg')
        },
        {
          name: 'FaqStopSmoking',
          title: 'Информация о социальном проекте Demis Group',
          text: 'Цель нашей компании - помочь максимальному количеству курильщиков в России и СНГ с легкостью бросить курить, рассказав им о методе Аллена Карра и о его правильном применении.',
          img: require('../../img/faq/06.jpg')
        },
        {
          name: 'FaqPersonalData',
          title: 'Владельцам сайтов: изменения в Законе «О персональных данных»',
          text: 'С 1 июля 2017 года вступает в силу Федеральный закон от 07.02.2017 № 13-ФЗ об обработке персональных данных.',
          img: require('../../img/faq/07.jpg')
        }
      ]
    }
  }
}
</script>

<style scoped>
.articles {
  display: flex;
  flex-wrap: wrap;
}

.articles .article-preview-container {
  cursor: pointer;
}

.articles > div {
  padding: 15px;
}

.articles .article-preview {
  height: 100%;
  background-color: white;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.articles .article-preview,
.articles .article-preview .img {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.articles .article-preview .img {
  height: 200px;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.articles .article-preview .body {
  padding: 30px;
}

.articles .article-preview .body .title {
  font-size: 1.2em;
  font-weight: bold;
}

.btn {
  width: 100%;
}
</style>
